import React from 'react';
import { PractitionerFormCardComponent } from '../../../../components/Cards';
import { usePractitioner } from '../../../../contexts/practitioner';
import { useOrganization } from '../../../../contexts/organization';
import { AdministrativeGender } from '../../../../modules/unsw-fhir/Primitives';
import { createPractitioner } from '../../../../modules/unsw-fhir/Practitioner';
import {
  putPractitioner,
  postPractitioner,
} from '../../../../apis/practitioner';
import { createPractitionerRole } from '../../../../modules/unsw-fhir/PractitionerRole';
import {
  putPractitionerRole,
  postPractitionerRole,
} from '../../../../apis/practitionerRole';

const capitalize = (s: string | undefined) => {
  if (typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
};

const PractitionerForm = ({
  onComplete,
}: {
  onComplete?: (practitionerId: string) => void;
}) => {
  const {
    getEmail,
    getFirstName,
    getLastName,
    getRoles,
    getGender,
    practitioner,
    practitionerRoles,
  } = usePractitioner();
  const { organization } = useOrganization();
  const gender = getGender() as AdministrativeGender;
  if (!organization || !organization.id) return null;
  return (
    <PractitionerFormCardComponent
      initialValues={
        practitioner
          ? {
              email: getEmail() || '',
              firstName: getFirstName(),
              lastName: getLastName(),
              gender: { value: gender, label: capitalize(gender) },
              role: getRoles().map(role => ({
                value: role.code,
                label: role.display,
              }))[0],
            }
          : undefined
      }
      onSubmit={async values => {
        let newPractitioner = createPractitioner(
          values.firstName,
          values.lastName,
          values.email,
          values.gender.value as AdministrativeGender,
          practitioner && practitioner.id,
        );

        const response =
          practitioner && practitioner.id
            ? await putPractitioner(practitioner.id, newPractitioner)
            : await postPractitioner(newPractitioner);

        if (!response || !response.id || !organization || !organization.id)
          return;
        const oldRole = practitionerRoles && practitionerRoles[0];
        const newRole = createPractitionerRole(
          response.id,
          organization.id,
          { code: values.role.value, display: values.role.label },
          oldRole && oldRole.id,
        );

        oldRole && oldRole.id
          ? await putPractitionerRole(oldRole.id, newRole)
          : await postPractitionerRole(newRole);

        if (onComplete) onComplete(response.id);
      }}
    />
  );
};
export default PractitionerForm;
